import css from 'styled-jsx/css';

export default css`.login-content {
    position: relative;
    padding: 32px 0;
    &-flex {
        display: flex;
        background-color: #fff;
        min-height: 420px;
        box-shadow: 0 3px 6px -4px rgb(0 0 0 / 12%), 0 6px 16px 0 rgb(0 0 0 / 8%), 0 9px 28px 8px rgb(0 0 0 / 5%);
        border-radius: 8px;
        overflow: hidden;
        .left {
            width: 240px;
            background: #aaa;
        }
        .right {
            flex: 1;
        }
    }
    .top-close-icon {
        position: absolute;
        top: 0;
        right: 0;
        font-size: 0;
        width: 16px;
        height: 16px;
        cursor: pointer;
        :global(svg) {
            width: 100%;
            height: 100%;
        }
    }

}`